<template>
  <div class="purchase-detail-box">
    <!-- <div class="status-wrap flex-none">
      <i @click="goBack()" class="cubeic-back"></i>
      <div class="title client-filter">
        终端拜访
        <button
          class="fr go-purchaseDetail"
          @click="goPurchaseDetail(clientDetail)"
        >
          拜访记录
        </button>
      </div>
    </div> -->
    <v-title
      title="终端拜访"
      :isShowBack="true"
      :isDefaultBack="false"
      btnText="拜访记录"
      @rightHandle="goPurchaseDetail(clientDetail)"
      @backHandle="goBack()"
    >
    </v-title>
    <div class="purchase-header" v-show="loading === false">
      <div>
        <span class="clientName">{{ clientDetail.clientName }}</span>
        <button
          type="button"
          class="cover-btn covered fr"
          v-if="clientDetail.visitStatus"
        >
          已拜访
        </button>
        <button type="button" class="cover-btn un-cover fr" v-else>
          未拜访
        </button>
      </div>
      <div class="purchase-header-list">
        <div class="purchase-header-item clearfix">
          <div>{{ clientDetail.clientAddress !== "" ? clientDetail.clientAddress : "暂无" }}</div>
          <div>
            <div class="info">
              <div>
                电话：{{ clientDetail.phone ? clientDetail.phone : "暂无" }}&nbsp;&nbsp;
              </div>
              <div>最近拜访时间：{{ clientDetail.lastVisitTime !== null ? clientDetail.lastVisitTime : "暂无" }}</div>
            </div>
            <div class="icon">
              <div class="choice-list" @click="showActionSheet(clientDetail)">
                <img :src="require('@/assets/feedback/location.png')" alt="">
                <div>导航</div>
              </div>
              <div class="choice-list-phone">
                <a
                  @click="pushUserLog('点击电话号码')"
                  v-if="clientDetail.phone"
                  :href="`tel:${clientDetail.phone}`"
                >
                  <img :src="require('@/assets/feedback/telephone.png')" alt="">
                  <div>电话</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="purchase-main">
      <div class="navBar">
        <cube-scroll-nav-bar
          :current="current"
          :labels="labels"
          :txts="txts"
          @change="handleClick"
          class="scrollNav"
        />
      </div>
      <div ref="customerProduct" v-show="current === '产品信息1'" class="fillForm">
        <div class="purchase-main-list">
          <cube-form
            :model="productModel"
            @validate="proValidateHandler"
          >
            <cube-form-group >
              <cube-form-item v-for="(item, index) in productField" :key="item.label" :field="productField[index]"></cube-form-item>
            </cube-form-group>
          </cube-form>
        </div>
      </div>
      <div ref="customerProduct" v-show="current === '产品信息2'" class="fillForm">
        <div class="purchase-main-list">
          <cube-form
            :model="competitiveProductModel"
            @validate="comValidateHandler"
          >
            <cube-form-group >
              <cube-form-item v-for="(item, index) in competitiveProductField" :key="item.label" :field="competitiveProductField[index]"></cube-form-item>
            </cube-form-group>
          </cube-form>
        </div>
      </div>
      <div ref="else" v-show="current === '其他信息'" class="fillForm">
        <div class="">
          <cube-form
            :model="otherInfoForm"
            @validate="othValidateHandler"
          >
            <cube-form-group>
              <cube-form-item :field="field[0]"></cube-form-item>
              <cube-form-item :field="field[1]"></cube-form-item>
              <cube-form-item :field="field[2]"></cube-form-item>
            </cube-form-group>
          </cube-form>
        </div>
      </div>
      <button
        type="button"
        class="btn-item navigation"
        :disabled="buttonEnable"
        v-show="isOriginHei"
        @click="handleSubmit(clientDetail)"
      >
        提交拜访
      </button>
    </div>
    <custom-loading v-if="loading" :isMask="true"></custom-loading>
  </div>
</template>

<script>
// import { purchaseDetail } from '@/api/feedBack'
import { isWeiXin } from '@/utils/utils'
import { getProductList, getCompetitiveProductList, addOrCommitVisit } from '@/api/clientVisit'
import CustomLoading from '@/components/CustomLoading.vue'
// import _ from 'lodash'
// import { sortByItems } from '@antv/s2/esm/utils/data-set-operate'
export default {
  name: 'visitFill',
  components: {
    CustomLoading
  },
  computed: {
    refName () {
      if (this.current === '产品信息1') {
        return 'customerProduct'
      } else if (this.current === '产品信息2') {
        return 'rivalProduct'
      } else {
        return 'else'
      }
    }
  },
  watch: {
    screenHeight () {
      if (this.originHeight > this.screenHeight) {
        this.isOriginHei = false
      } else {
        this.isOriginHei = true
      }
    }
  },
  created () {
    this.clientDetail = JSON.parse(this.$route.query.data)
    console.log('////////', this.clientDetail)
    this.searchData = JSON.parse(this.$route.query.searchData)
    console.log(111, this.$route.query.searchData)
    this.getVisitProductList()
    this.getClientCompetitiveProductList()
  },
  mounted () {
    const self = this
    const originalHeight = document.documentElement.clientHeight || document.body.clientHeight
    window.onresize = function() {
      return (function() {
        self.screenHeight = document.documentElement.clientHeight
        const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
        if (resizeHeight - 0 < originalHeight - 0) {
          // 当软键盘弹起，在此处操作
          document.querySelector('body').setAttribute('style', 'height:' + originalHeight + 'px;')
          this.scrollerHeight = resizeHeight
        } else {
          // 当软键盘收起，在此处操作
          document.querySelector('body').setAttribute('style', 'height:100%;')
          this.scrollerHeight = '100%'
        }
      })()
    }
  },
  data () {
    return {
      buttonEnable: false,
      otherInfoForm: {},
      productModel: {},
      competitiveProductModel: {},
      prductModel: {},
      competitiveProductModal: {},
      productField: [],
      competitiveProductField: [],
      isOriginHei: true,
      screenHeight: document.documentElement.clientHeight,
      originHeight: document.documentElement.clientHeight,
      field: [
        {
          type: 'input',
          modelKey: 'contacts',
          label: '联系人',
          props: {
            placeholder: '请输入联系人'
          },
          rules: {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
            max: 10,
            min: 1,
            message: '请输入1-10个字符！'
          },
          messages: {
            pattern: '请输入1-10个汉字大小写英文或数字'
          }
        },
        {
          type: 'input',
          modelKey: 'contactsNumber',
          label: '电话',
          props: {
            placeholder: '请输入电话'
          },
          rules: {
            pattern: /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/
          },
          messages: {
            pattern: '请输入正确的电话号码'
          }
        },
        {
          type: 'textarea',
          modelKey: 'remark',
          label: '备注',
          props: {
            placeholder: '请输入备注',
            maxlength: 30
          },
          rules: {
            // pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
            max: 30
          }
        }],
      current: '产品信息1',
      labels: ['产品信息1', '产品信息2', '其他信息'],
      txts: ['产品信息1', '产品信息2', '其他信息'],
      loading: false,
      keyword: '',
      clientDetail: {},
      detailData: {},
      searchData: '',
      productValid: undefined,
      competitiveValid: undefined,
      otherInfoValid: undefined
    }
  },

  filters: {
  },
  methods: {
    proValidateHandler(result) {
      this.productValid = result.valid
    },
    comValidateHandler(result) {
      this.competitiveValid = result.valid
    },
    othValidateHandler(result) {
      this.otherInfoValid = result.valid
    },
    getVisitProductList () {
      getProductList().then((res) => {
        const products = res.data
        for (let i = 0; i < products.length; i++) {
          this.productField.push({
            type: 'input',
            modelKey: products[i],
            label: products[i],
            props: {
              placeholder: '请输入拜访价'
            },
            rules: {
              message: { pattern: '只允许输入数字，支持输入5位整数和小数点后2位' },
              pattern: /^(^0\.\d{0,1}[0-9]$)|(^[1-9]\d{0,4}\.\d{1,2}$)|(^[1-9]\d{0,4})$/
              // pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
            },
            messages: {
              pattern: '只允许输入数字，支持输入5位整数和小数点后2位'
            }
          })
        }
      })
    },
    getClientCompetitiveProductList () {
      getCompetitiveProductList(this.clientDetail.cityCode).then((res) => {
        const competitiveProducts = res.data
        for (let i = 0; i < competitiveProducts.length; i++) {
          this.competitiveProductField.push({
            type: 'input',
            modelKey: competitiveProducts[i],
            label: competitiveProducts[i],
            props: {
              placeholder: '请输入拜访价'
            },
            rules: {
              message: { pattern: '只允许输入数字，支持输入5位整数和小数点后2位' },
              pattern: /^(^0\.\d{0,1}[0-9]$)|(^[1-9]\d{0,4}\.\d{1,2}$)|(^[1-9]\d{0,4})$/
              // pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
            },
            messages: {
              pattern: '只允许输入数字，支持输入5位整数和小数点后2位'
            }
          })
        }
      })
    },
    handleSubmit (clientDetail) {
      this.buttonEnable = true
      console.log(3434, this.productModel, this.competitiveProductModel, this.otherInfoForm)
      const { matchClientId, clientName, address, chainBrand, phone, provinceCode, provinceName, cityCode, cityName, districtCode, districtName } = clientDetail
      const querys = {}
      querys.matchClientId = matchClientId
      querys.clientName = clientName
      querys.address = address
      querys.chainBrand = chainBrand
      querys.phone = phone
      querys.provinceCode = provinceCode
      querys.provinceName = provinceName
      querys.cityCode = cityCode
      querys.cityName = cityName
      querys.districtCode = districtCode
      querys.districtName = districtName
      querys.clientInfo = this.otherInfoForm
      const productList = []
      const competitiveProduct = []
      for (const key in this.productModel) {
        if (this.productModel[key] !== '') {
          const temp = {}
          temp.productName = key
          temp.price = this.productModel[key]
          productList.push(temp)
        }
      }
      for (const key in this.competitiveProductModel) {
        if (this.competitiveProductModel[key] !== '') {
          const temp = {}
          temp.productName = key
          temp.price = this.competitiveProductModel[key]
          competitiveProduct.push(temp)
        }
      }
      querys.productList = productList
      querys.competitiveProduct = competitiveProduct
      if (this.productValid === false || this.competitiveValid === false || this.otherInfoValid === false) {
        this.$createDialog({
          title: '提示',
          type: 'alert',
          content: '请检查填写信息！'
        }).show()
        this.buttonEnable = false
      } else {
        this.toastsub = this.$createToast({
          txt: '正在提交。。。',
          time: 0,
          mask: false
        }).show()
        this.loading = true
        addOrCommitVisit(querys).then((res) => {
          this.loading = false
          if (res.code === 1) {
            this.toastsub.hide()
            this.$router.push({
              name: 'visitSuccess',
              query: {
                data: res.data
              }
            })
          } else {
            this.$message.error(res.reason)
          }
        }).finally(
          this.loading = false,
          this.toastsub.hide()
        )
      }
    },
    handleClick (cur) {
      this.current = cur
      // this.$nextTick(() => {
      //   this.$refs[this.refName].refreshAll()
      // })
    },
    goPurchaseDetail (clientDetail) {
      this.$router.push({
        name: 'clientVisitRecords',
        query: {
          data: clientDetail.matchClientId
        }
      })
    },
    // 显示导航操作列表
    showActionSheet (pointData) {
      const isWX = isWeiXin()
      if (isWX) {
        // 已获取定位时
        if (this.myPositionCenter) {
          this.$refs.mapDriving.show()
        } else {
          // 提示选择地区
          this.$createDialog({
            title: '提示',
            type: 'alert',
            content: '请先获取您的位置再进行路线导航！'
          }).show()
        }
        return false
      }
      this.$createActionSheet({
        data: [
          { content: '高德地图' },
          { content: '腾讯地图' },
          { content: '百度地图' }
        ],
        onSelect: (item, index) => {
          // 打开地图导航
          if (this.$store.state.UserAgent === 'ios') {
            if (index === 0) {
              // 高德地图时
              window.open(
                `iosamap://path?sourceApplication=applicationName&sid=BGVIS1&slat=39.92848272&slon=116.39560823&sname=我的位置&did=BGVIS2&dlat=${pointData.latitude}&dlon=${pointData.longitude}&dname=${pointData.clientName}&dev=0&t=0`
              )
            } else if (index === 1) {
              // 腾讯地图
              window.open(
                `qqmap://map/routeplan?type=drive&from=我的位置&fromcoord=CurrentLocation&to=${pointData.clientName}&tocoord=${pointData.latitude},${pointData.longitude}&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77`
              )
            } else if (index === 2) {
              // 百度地图
              window.open(
                `baidumap://map/direction?origin=我的位置&destination=name:${pointData.clientName}|latlng:${pointData.latitude},${pointData.longitude}&coord_type=gcj02&mode=driving&src=ios.sca.weiming`
              )
            }
          } else {
            if (index === 0) {
              // 高德地图时
              window.open(
                `amapuri://route/plan/?sourceApplication=amap&dlat=${pointData.latitude}&dlon=${pointData.longitude}&dev=1&t=0&dname=${pointData.clientName}`
              )
            } else if (index === 1) {
              // 腾讯地图
              window.open(
                `qqmap://map/routeplan?type=drive&from=我的位置&fromcoord=CurrentLocation&to=${pointData.clientName}&tocoord=${pointData.latitude},${pointData.longitude}&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77`
              )
            } else if (index === 2) {
              // 百度地图
              window.open(
                `bdapp://map/direction?origin=我的位置&destination=name:${pointData.clientName}|latlng:${pointData.latitude},${pointData.longitude}&coord_type=gcj02&mode=driving&src=andr.sca.weiming`
              )
            }
          }
        }
      }).show()
      // 上报操作日志
      this.pushUserLog('开始导航')
    },
    goBack () {
      // this.$router.push({name:'index'})
      this.$router.back()
    },
    // 回车事件
    submitHandle () {
      this.$emit('enter', this.keyword)
    },
    // 失去焦点时
    blurHandle () {
      this.$emit('blur', this.keyword)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/base/base.styl';

/deep/ .cube-scroll-nav-bar-item{
  padding: 25px 60px
}
/deep/ .cube-picker-wheel-wrapper{
  justify-content: center
}
/deep/ .cube-form_standard .cube-textarea-wrapper.cube-textarea_expanded {
  height: 160px
  padding-bottom: 10px
}
.purchase-detail-box {
  height: 100%;
  background: #efefef;
}
.fillForm {
    height: 600px
    overflow: scroll
  }
.status-wrap{
  padding 12px 15px
  position relative
  z-index 89
}
/deep/.right-btn{
  color #5785ea
}
/deep/ .cube-scroll-content{
  width: 100% !important
}
.go-purchaseDetail{
  font-size 32px
  height 32px
  position absolute
  top 12px
  right 0
  color #5785ea
}

.cubeic-back {
  position: absolute;
  font-size: 50px;
  left: 1px;
  top: -3px
  margin-bottom: 10px
  color: #4d8ee3;
}

.title {
  text-align: center
  font-size 36px
}
.purchase-header {
  padding: 116px 24px 16px;
  background: #fff;

  .clientName {
    width: 75%
    font-size: 30px;
    color: #333;
    font-weight: bold;
  }
  .cover-btn {
    width 86px
    height 42px
    border-radius 3px
    font-size $font-S
    color $color-white
    right 24px
    &.covered {
        background $color-main
    }
    &.un-cover {
        background $color-red
    }
  }
  .info{
    display: inline
    float: left
    width: 70%
    div {
      margin: 10px auto
    }
  }
  .icon{
    float: right
    width: 30%
    height: 100%
    text-align: center
    top: 30px
  }
  .choice-list {
    font-size: 16px
    height: 100%
    float: right
    margin: 20px
    img {
      width: 40px;
      height: 40px;
      margin-bottom: 10px
    }
  }
  .choice-list-phone{
    margin: 20px
    font-size: 16px
    height: 100%
    float: right
    right 8px
    a{
      color: #666;
    }
    img {
      width: 40px;
      height: 40px;
      margin-bottom: 10px
    }
  }
  .purchase-header-list {
    .purchase-header-item {
      min-height: 120px
      margin-top: 24px;
      color: #666;
      font-size: 26px;
    }
  }
}

.purchase-main {
  padding-bottom: 50px
  .navBar {
    margin-top: 20px;
    margin-bottom: 5px
  }
  .purchase-main-list {
    background: #fff;
    /deep/ .cube-form_standard .cube-form-label {
      width: 500px
      padding: 15px 25px 15px 0
    }
    h4, .purchase-main-list-item {
      width: 686px;
      margin: 0 auto;
    }

    h4 {
      padding-top: 36px;
      line-height: 1;
      color: #333;
      font-size: 30px;
      font-weight: bold;
    }

    .purchase-main-list-item {
      border-bottom: 2px solid #efefef;
      padding-bottom: 36px;
      padding-top: 26px;
      color: #666;
      line-height: 1;
      font-size: 26px;

      .price-box {
        text-align: end;
        .count {
          margin-right: 4px;
        }
      }
    }
  }
  .foot {
    margin-bottom: 50px
  }
  .btn-item{
    position: fixed
    bottom: 0px
    left: 0
    right: 0
    display:block
    margin:30px auto
    width 654px
    height 88px
    border-radius: 8px
    &.navigation{
      text-align: center
      font-size $font-XXXL
      color $color-white
      background $color-main
    }
  }
}
</style>
<style scoped>
</style>
